import { ShapeTool } from ".";

const fabric = require("../fabric").fabric;

export class TextTool extends ShapeTool {

  buildShape(pointer, origX, origY) {
    let styleModule = this.imageEditor.getModule("style");

    return new fabric.IText("", {
      fill: styleModule.fillColor,
      stroke: "white",
      strokeWidth: 0,
      color: styleModule.fillColor,
      cursorColor: styleModule.fillColor,
      transparentCorners: false,
      fontSize: styleModule.strokeSize,
      fontFamily: "Arial",
      editable: true,
      fontWeight: 800,
      left: origX,
      top: origY,
      selectable: false
    });
  }

  shapePlaced(text) {
    this.imageEditor.canvas.setActiveObject(text);
    text.enterEditing();
  }

}